'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _classCallCheck = require('@babel/runtime/helpers/classCallCheck');
var _createClass = require('@babel/runtime/helpers/createClass');
var _assertThisInitialized = require('@babel/runtime/helpers/assertThisInitialized');
var _inherits = require('@babel/runtime/helpers/inherits');
var _possibleConstructorReturn = require('@babel/runtime/helpers/possibleConstructorReturn');
var _getPrototypeOf = require('@babel/runtime/helpers/getPrototypeOf');
var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var React = require('react');
var metrics = require('pobble-components/dist/metrics');
var modal = require('pobble-components/dist/modal');
var Button = require('pobble-components/dist/button');
var injectSheet = require('react-jss');
var setup = require('pobble-components/dist/setup');
var schoolIcon = require('pobble-components/dist/pobble-user/school.gif');
var THEME = require('pobble-components/dist/theme');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var jssMixins = require('pobble-components/dist/jss-mixins');
var classNames = require('classnames');
var PropTypes = require('prop-types');
var FullpageError = require('pobble-components/dist/full-page-error');
var authHelpers = require('pobble-components/dist/auth-helpers');
var utils = require('pobble-components/dist/utils');
var DevPage = require('pobble-components/dist/dev-page');
var selectRole = require('pobble-components/dist/select-role');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _assertThisInitialized__default = /*#__PURE__*/_interopDefaultLegacy(_assertThisInitialized);
var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
var _possibleConstructorReturn__default = /*#__PURE__*/_interopDefaultLegacy(_possibleConstructorReturn);
var _getPrototypeOf__default = /*#__PURE__*/_interopDefaultLegacy(_getPrototypeOf);
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutProperties);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Button__default = /*#__PURE__*/_interopDefaultLegacy(Button);
var injectSheet__default = /*#__PURE__*/_interopDefaultLegacy(injectSheet);
var schoolIcon__default = /*#__PURE__*/_interopDefaultLegacy(schoolIcon);
var THEME__default = /*#__PURE__*/_interopDefaultLegacy(THEME);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var FullpageError__default = /*#__PURE__*/_interopDefaultLegacy(FullpageError);
var DevPage__default = /*#__PURE__*/_interopDefaultLegacy(DevPage);

var PobbleUserContext = /*#__PURE__*/React__default["default"].createContext();

var _excluded$1 = ["classes"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf__default["default"](Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf__default["default"](this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn__default["default"](this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var FONT_SIZES = THEME__default["default"].FONT_SIZES,
    COLORS$1 = THEME__default["default"].COLORS;
var schoolRequiredStyles = {
  content: {
    textAlign: 'center',
    minWidth: '460px',
    padding: '100px 0',
    '@media (max-width: 575px)': {
      minWidth: 'auto'
    },
    '& > h2': _objectSpread$3(_objectSpread$3({}, FONT_SIZES.HEADING_BIG.STYLE), {}, {
      margin: '0 0 14px'
    }),
    '& > p': {
      margin: '0 0 28px'
    }
  },
  icon: {
    width: '100px',
    marginBottom: '28px',
    color: COLORS$1.TEXT.LIGHT_GREY.NORMAL
  },
  modalOverlay: {
    zIndex: '9999'
  }
};
var SchoolRequiredModal = injectSheet__default["default"](schoolRequiredStyles)(function (_ref) {
  var classes = _ref.classes,
      props = _objectWithoutProperties__default["default"](_ref, _excluded$1);

  return /*#__PURE__*/React__default["default"].createElement(modal.Modal, _extends__default["default"]({
    overlayClassName: classes.modalOverlay
  }, props, {
    closeButton: true
  }), /*#__PURE__*/React__default["default"].createElement(modal.ModalContent, {
    legacy: true,
    className: classes.content
  }, /*#__PURE__*/React__default["default"].createElement("img", {
    src: schoolIcon__default["default"],
    alt: "School",
    className: classes.icon
  }), /*#__PURE__*/React__default["default"].createElement("h2", null, "You need to be a part of", /*#__PURE__*/React__default["default"].createElement("br", null), "a school to access this"), /*#__PURE__*/React__default["default"].createElement("p", null, "If you haven't already done so,", /*#__PURE__*/React__default["default"].createElement("br", null), "please request access to a school", /*#__PURE__*/React__default["default"].createElement("br", null), "from your profile page."), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    tall: true,
    href: "".concat(setup.URLS.ACCOUNT, "#school")
  }, "Request school access")));
});

var onUserDataFetched = function onUserDataFetched(user) {
  var id = user.account.id;
  metrics.gtmDataLayer({
    userId: id,
    pobble_id: id
  });
};

var UserProvider = /*#__PURE__*/function (_Component) {
  _inherits__default["default"](UserProvider, _Component);

  var _super = _createSuper(UserProvider);

  function UserProvider(props) {
    var _this;

    _classCallCheck__default["default"](this, UserProvider);

    _this = _super.call(this, props);

    _defineProperty__default["default"](_assertThisInitialized__default["default"](_this), "fetchMe", function () {
      var fetchMe = _this.props.fetchMe;
      var value = _this.state.value;

      _this.setState({
        value: _objectSpread$3(_objectSpread$3({}, value), {}, {
          request: {
            pending: true,
            error: null
          }
        })
      });

      return fetchMe().then(function (res) {
        onUserDataFetched(res.data);

        _this.setState({
          value: _objectSpread$3(_objectSpread$3({}, value), {}, {
            request: {
              pending: false,
              error: null
            },
            me: res.data
          })
        });

        return res;
      })["catch"](function (err) {
        _this.setState({
          value: _objectSpread$3(_objectSpread$3({}, value), {}, {
            request: {
              pending: false,
              error: err.response || err
            }
          })
        }); // Do not throw an error if user just unauthorized


        if (err.response.status !== 401) {
          throw err;
        }
      });
    });

    _this.state = {
      value: {
        me: null,
        request: {
          pending: true,
          error: null
        },
        refetchMe: _this.fetchMe,
        schoolRequiredOpen: false,
        showSchoolRequiredDialog: function showSchoolRequiredDialog() {
          return _this.setState({
            value: _objectSpread$3(_objectSpread$3({}, _this.state.value), {}, {
              schoolRequiredOpen: true
            })
          });
        },
        updateMe: function updateMe(updater) {
          return _this.setState({
            value: _objectSpread$3(_objectSpread$3({}, _this.state.value), {}, {
              me: updater(_this.state.value.me)
            })
          });
        }
      }
    };
    return _this;
  }

  _createClass__default["default"](UserProvider, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetchMe();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var children = this.props.children;
      var value = this.state.value;
      return /*#__PURE__*/React__default["default"].createElement(PobbleUserContext.Provider, {
        value: value
      }, children, /*#__PURE__*/React__default["default"].createElement(SchoolRequiredModal, {
        requestClose: function requestClose() {
          _this2.setState({
            value: _objectSpread$3(_objectSpread$3({}, _this2.state.value), {}, {
              schoolRequiredOpen: false
            })
          });
        },
        isOpen: this.state.value.schoolRequiredOpen
      }));
    }
  }]);

  return UserProvider;
}(React.Component);

var withMe = function withMe(WrappedComponent) {
  return function (props) {
    return /*#__PURE__*/React__default["default"].createElement(PobbleUserContext.Consumer, null, function (_ref) {
      var me = _ref.me,
          refetchMe = _ref.refetchMe,
          request = _ref.request,
          updateMe = _ref.updateMe,
          updateUserState = _ref.updateUserState,
          showSchoolRequiredDialog = _ref.showSchoolRequiredDialog;
      return /*#__PURE__*/React__default["default"].createElement(WrappedComponent, _extends__default["default"]({
        me: me,
        refetchMe: refetchMe,
        meRequest: request,
        updateMe: updateMe,
        updateUserState: updateUserState,
        showSchoolRequiredDialog: showSchoolRequiredDialog
      }, props));
    });
  };
};

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var styles$8 = {
  container: _objectSpread$2({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }, jssMixins.fullVHExceptHeader),
  spinner: {
    opacity: '0',
    animation: '0.6s fadeIn ease-in forwards'
  },
  '@keyframes fadeIn': {
    from: {
      opacity: '0'
    },
    to: {
      opacity: '1'
    }
  }
};

var COLORS = THEME__default["default"].COLORS;
var styles$7 = {
  spinner: {
    fontSize: '40px',
    width: '1em',
    height: '1em',
    position: 'relative',
    animation: 'spCircRot .6s infinite linear',
    padding: '2px',
    color: COLORS.BLUE.NORMAL,
    '& > div': {
      position: 'relative',
      width: '100%',
      height: '100%',
      '&:after': {
        content: '""',
        border: '2px solid currentColor',
        position: 'absolute',
        left: '-2px',
        top: '-2px',
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        opacity: '.3',
        zIndex: '100'
      },
      '&:before': {
        content: '""',
        position: 'absolute',
        left: '-2px',
        top: '-2px',
        width: '100%',
        height: '100%',
        border: '2px solid transparent',
        borderTop: '2px solid currentColor',
        borderRadius: '50%',
        zIndex: '110'
      }
    }
  },
  '@keyframes spCircRot': {
    from: {
      transform: 'rotate(0deg)'
    },
    to: {
      transform: 'rotate(359deg)'
    }
  }
};

var _excluded = ["classes", "className"];

var Spinner = function Spinner(_ref) {
  var classes = _ref.classes,
      className = _ref.className,
      props = _objectWithoutProperties__default["default"](_ref, _excluded);

  return /*#__PURE__*/React__default["default"].createElement("div", _extends__default["default"]({
    className: classNames__default["default"](classes.spinner, className)
  }, props), /*#__PURE__*/React__default["default"].createElement("div", null));
};

Spinner.propTypes = {
  /** Additional className to restyle component */
  className: PropTypes__default["default"].string,

  /** Rewrite style of the component */
  style: PropTypes__default["default"].object
};
var Spinner$1 = injectSheet__default["default"](styles$7)(Spinner);

var LoadingScreen = function LoadingScreen(_ref) {
  var classes = _ref.classes;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React__default["default"].createElement(Spinner$1, {
    className: classes.spinner
  }));
};

var LoadingScreen$1 = injectSheet__default["default"](styles$8)(LoadingScreen);

var styles$6 = {
  img: {
    width: '200px',
    height: '200px',
    margin: '0 0 20px'
  },
  button: {
    paddingLeft: '40px',
    paddingRight: '40px'
  }
};

var UnauthorisedScreen = function UnauthorisedScreen() {
  return /*#__PURE__*/React__default["default"].createElement(FullpageError__default["default"], {
    monster: "unplug",
    title: "There appears to be a technical error",
    status: "Oops!",
    desc: /*#__PURE__*/React__default["default"].createElement(React.Fragment, null, "We have logged the error.", /*#__PURE__*/React__default["default"].createElement("br", null), "If this continues to happen, please", /*#__PURE__*/React__default["default"].createElement("br", null), "contact hello@pobble.com.")
  });
};

var UnknownErrorScreen = injectSheet__default["default"](styles$6)(UnauthorisedScreen);

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var styles$5 = (function (_ref) {
  var FONT_SIZES = _ref.FONT_SIZES;
  return {
    container: _objectSpread$1(_objectSpread$1({}, FONT_SIZES.BODY_LARGE.STYLE), {}, {
      textAlign: 'center',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      animation: '0.5s fadeIn',
      width: '100%'
    }, jssMixins.fullVHExceptHeader),
    holder: {
      maxWidth: '370px',
      width: '100vw',
      background: '#fff',
      padding: '40px',
      border: '1px solid #ececec',
      borderRadius: '10px'
    },
    '@keyframes fadeIn': {
      from: {
        opacity: 0
      },
      to: {
        opacity: 1
      }
    }
  };
});

var Container = function Container(_ref) {
  var classes = _ref.classes,
      children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: classNames__default["default"](classes.container, className)
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: classes.holder
  }, children));
};

var Container$1 = injectSheet__default["default"](styles$5)(Container);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var styles$4 = (function (_ref) {
  var FONT_SIZES = _ref.FONT_SIZES;
  return {
    title: _objectSpread({
      margin: '0 0 25px'
    }, FONT_SIZES.HEADING_BIG.STYLE)
  };
});

var Title = function Title(_ref) {
  var classes = _ref.classes,
      children = _ref.children;
  return /*#__PURE__*/React__default["default"].createElement("h2", {
    className: classes.title
  }, children);
};

var Title$1 = injectSheet__default["default"](styles$4)(Title);

var styles$3 = {
  container: {
    margin: '0 0 30px',
    '& a': {
      color: 'currentColor'
    },
    '& > p': {
      margin: '15px 0 0',
      '&:first-child': {
        margin: '0'
      }
    }
  }
};

var Description = function Description(_ref) {
  var classes = _ref.classes,
      children = _ref.children;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: classes.container
  }, children);
};

var Description$1 = injectSheet__default["default"](styles$3)(Description);

var FSUScreen = function FSUScreen() {
  return /*#__PURE__*/React__default["default"].createElement(Container$1, null, /*#__PURE__*/React__default["default"].createElement(Title$1, null, "Almost done!"), /*#__PURE__*/React__default["default"].createElement(Description$1, null, /*#__PURE__*/React__default["default"].createElement("p", null, "We need a little more information to finish setting up your account.")), /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
    tall: true,
    action: function action() {
      return authHelpers.redirectToAuth({
        route: 'finish-signup',
        redirectBack: true
      });
    }
  }, "Complete your account"));
};

var styles$2 = {
  img: {
    width: '200px',
    height: '200px',
    margin: '0 0 20px'
  },
  button: {
    paddingLeft: '40px',
    paddingRight: '40px'
  }
};

var SignInButton = /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
  tall: true,
  href: "/auth/?redirect=".concat(window.location.href)
}, "Sign into Pobble");

var NoRightsScreen = function NoRightsScreen() {
  return /*#__PURE__*/React__default["default"].createElement(FullpageError__default["default"], {
    monster: "guard",
    title: "You are not allowed to view this page",
    status: "403",
    desc: /*#__PURE__*/React__default["default"].createElement(React.Fragment, null, "If you think this is an error,", /*#__PURE__*/React__default["default"].createElement("br", null), "please contact hello@pobble.com."),
    button: SignInButton
  });
};

var NoRightsScreen$1 = injectSheet__default["default"](styles$2)(NoRightsScreen);

var styles$1 = {};

var SchoolRequiredScreen = function SchoolRequiredScreen() {
  return /*#__PURE__*/React__default["default"].createElement(FullpageError__default["default"], {
    monster: "guard",
    title: /*#__PURE__*/React__default["default"].createElement(React.Fragment, null, "You need to be", /*#__PURE__*/React__default["default"].createElement("br", null), "part of a school to access this feature"),
    desc: /*#__PURE__*/React__default["default"].createElement(React.Fragment, null, "You can request access", /*#__PURE__*/React__default["default"].createElement("br", null), "on your profile page"),
    button: /*#__PURE__*/React__default["default"].createElement(Button__default["default"], {
      tall: true,
      href: setup.URLS.ACCOUNT
    }, "Go to profile page")
  });
};

var SchoolRequiredScreen$1 = injectSheet__default["default"](styles$1)(SchoolRequiredScreen);

var styles = {};

var env = utils.getPobbleEnv();

var redirectToConflictsResolutionTool = function redirectToConflictsResolutionTool() {
  window.location.replace("".concat(setup.URLS.APP, "/dashboard/conflict-resolution"));
  return null;
};

var devMode = env === 'local';
var RoleSelectionModal = injectSheet__default["default"]({
  content: {
    maxWidth: '760px'
  }
})(function (_ref) {
  var classes = _ref.classes;

  var _useState = React.useState(true),
      _useState2 = _slicedToArray__default["default"](_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  return /*#__PURE__*/React__default["default"].createElement(modal.Modal, {
    isOpen: open
  }, /*#__PURE__*/React__default["default"].createElement(modal.ModalContent, {
    className: classes.content
  }, /*#__PURE__*/React__default["default"].createElement(selectRole.SelectRole, {
    onSuccess: function onSuccess() {
      return setOpen(false);
    },
    onError: function onError() {
      return setOpen(false);
    }
  })));
});

var UserInspector = function UserInspector(_ref2) {
  var classes = _ref2.classes,
      me = _ref2.me,
      meRequest = _ref2.meRequest,
      children = _ref2.children,
      disableFSU = _ref2.disableFSU,
      haveRights = _ref2.haveRights,
      schoolRequired = _ref2.schoolRequired,
      _ref2$authRedirect = _ref2.authRedirect,
      authRedirect = _ref2$authRedirect === void 0 ? true : _ref2$authRedirect;
  if (!authHelpers.getToken() && !devMode) return authHelpers.redirectToAuth({
    redirectBack: authRedirect
  });
  if (meRequest.pending) return /*#__PURE__*/React__default["default"].createElement(LoadingScreen$1, null);

  if (meRequest.error) {
    if (meRequest.error.status === 401) {
      return devMode ? /*#__PURE__*/React__default["default"].createElement(DevPage__default["default"], null) : authHelpers.redirectToAuth({
        redirectBack: authRedirect
      });
    } else {
      console.error('Pobble user error:', meRequest.error);
      return /*#__PURE__*/React__default["default"].createElement(UnknownErrorScreen, null);
    }
  }

  var PullProviderConflictResolution = me.account.policy.pull_provider && me.account.policy.pull_provider.start_conflict_resolution || me.account.policy.wonde && me.account.policy.wonde.start_conflict_resolution;
  var finish_signup_status = me.account.finish_signup_status;
  if (!disableFSU && !finish_signup_status.finished) return /*#__PURE__*/React__default["default"].createElement(FSUScreen, null);
  if (haveRights && !haveRights(me)) return /*#__PURE__*/React__default["default"].createElement(NoRightsScreen$1, null);
  if (schoolRequired && !me.account.policy.teacher_in_school) return /*#__PURE__*/React__default["default"].createElement(SchoolRequiredScreen$1, null);

  if (PullProviderConflictResolution && window.location.href.indexOf('conflict-resolution') === -1 && window.location.host !== 'admin.pobble.com') {
    return redirectToConflictsResolutionTool();
  }

  var ROLE_NOT_SELECTED = me && me.account && me.account.role_in_life === 'not_selected';
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
    className: classes.container
  }, children), ROLE_NOT_SELECTED && /*#__PURE__*/React__default["default"].createElement(RoleSelectionModal, null));
};

var userInspector = withMe(injectSheet__default["default"](styles)(UserInspector));

var useMe = function useMe() {
  var _useContext = React.useContext(PobbleUserContext),
      me = _useContext.me,
      refetchMe = _useContext.refetchMe,
      request = _useContext.request,
      updateMe = _useContext.updateMe,
      showSchoolRequiredDialog = _useContext.showSchoolRequiredDialog;

  return {
    me: me,
    refetchMe: refetchMe,
    meRequest: request,
    updateMe: updateMe,
    showSchoolRequiredDialog: showSchoolRequiredDialog
  };
};

exports.UserInspector = userInspector;
exports.UserProvider = UserProvider;
exports.useMe = useMe;
exports.withMe = withMe;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// /codebuild/output/src1478882582/src/pobble-app/client/~/pobble-components/dist/pobble-user/index.js